module.exports = __webpack_public_path__ + "static/img/定制开发.643b3735.png";